export enum IdTokenProvider {
    Apple = 'apple',
    Google = 'google',
}
